"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.wizardUserGetManyOutputDtoSchema = exports.wizardUserSchema = exports.wizardUserMembershipSchema = exports.userCapabilityStateSchema = exports.wizardUserGetManyInputDtoSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
exports.wizardUserGetManyInputDtoSchema = z.object({
    cursor: z.string().optional(),
    limit: z.number().int().positive().max(cadstrom_shared_1.QueryBuilder.MAX_PAGE_LIMIT).optional(),
});
exports.userCapabilityStateSchema = z.record(z.string(), z.boolean());
exports.wizardUserMembershipSchema = z.object({
    organizationId: z.string(),
    role: z.nativeEnum(cadstrom_shared_1.Auth.MembershipRole),
});
exports.wizardUserSchema = z.object({
    id: z.string(),
    invitePending: z.boolean(),
    username: z.string(),
    displayName: z.string().nullable(),
    email: z.string(),
    capabilities: exports.userCapabilityStateSchema,
    memberships: z.array(exports.wizardUserMembershipSchema),
    hasOrgPolicyAccess: z.boolean(),
});
exports.wizardUserGetManyOutputDtoSchema = z.object({
    users: z.array(exports.wizardUserSchema),
    endCursor: z.string().nullable(),
    hasNextPage: z.boolean(),
    totalCount: z.number(),
});
//# sourceMappingURL=wizard-user-get-many.dto.js.map